import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import BaseModal from './BaseModal'
import verifyImg from '../../assets/images/verify.png'

const UploadID = () => {
    return (
        <BaseModal modalId="modalUploadID" modalTitle="Upload ID" modalTitleIcon={faAddressCard}>
            <form action="#" method="post" className="text-dark text-center">
                <img src={verifyImg} alt="Verify" className="rounded-circle w-50 m-auto" />
                <div className="form-group">
                    <div className="input-group">
                        <input type="file" name="avatar" className="form-control" />
                        <div className="input-group-append">
                            <div className="input-group-text"> Front</div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="input-group">
                        <input type="file" name="avatar" className="form-control" />
                        <div className="input-group-append">
                            <div className="input-group-text">Back &nbsp; </div>
                        </div>
                    </div>
                </div>
                <button type="submit" className="btn btn-purple shadow-sm w-100 mt-4">Verify <FontAwesomeIcon icon={faCheckCircle} /></button>
            </form>
        </BaseModal>
    )
}

export default UploadID